/** Redondeo de botones en % del lado menor (0–50, píldora ≈ 50). */
export function getButtonBorderRadiusPercent(style = {}) {
	if (style.borderRadiusPercent != null && Number.isFinite(Number(style.borderRadiusPercent))) {
		return Math.max(0, Math.min(50, Number(style.borderRadiusPercent)));
	}
	if (style.borderRadius != null && Number.isFinite(Number(style.borderRadius))) {
		return Math.max(0, Math.min(50, Number(style.borderRadius)));
	}
	return 8;
}

export function resolveButtonBorderRadiusCss(style = {}) {
	if (style.borderRadiusPercent != null && Number.isFinite(Number(style.borderRadiusPercent))) {
		const p = Math.max(0, Math.min(50, Number(style.borderRadiusPercent)));
		return p > 0 ? `${p}%` : 0;
	}
	if (style.borderRadius != null && Number.isFinite(Number(style.borderRadius))) {
		const px = Math.max(0, Number(style.borderRadius));
		return px > 0 ? px : 0;
	}
	return "8%";
}
